import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from "moment";
import _ from 'lodash';
import { AlertController, ToastController } from 'ionic-angular';
import { DatabaseProvider } from '../database/database';

@Injectable()
export class UtilityProvider {

  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private db: DatabaseProvider
    ) {
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  pad(num, padlen, padchar) {
    var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
    var pad = new Array(1 + padlen).join(pad_char);
    return (pad + num).slice(-pad.length);
  }

  getDrugType(
    reimbursement_private?: any, 
    reimbursement_private_other?: any, 
    reimbursement_public?: any, 
    reimbursement_compassionate?: any
    ) {
    if (reimbursement_private) {
      if (reimbursement_private.active === 'Yes') return 'Commercial';
    }

    if (reimbursement_private_other) {
      if (reimbursement_private_other.active === 'Yes') return 'Commercial';
    }

    if (reimbursement_public) {
      if (reimbursement_public.active === 'Yes') return 'Commercial';
    }

    if (reimbursement_compassionate) {
      if (reimbursement_compassionate.active === 'Yes') return reimbursement_compassionate.type;
    }
  }

  getReimbursementType(
    reimbursement_private?: any, 
    reimbursement_private_other?: any, 
    reimbursement_public?: any, 
    reimbursement_compassionate?: any,
    reimbursement_fa?: any
    ): string | null {
    let type = '';
    if (reimbursement_private) {
      if (reimbursement_private.active === 'Yes') type += 'Private';
    }

    if (reimbursement_private_other) {
      if (reimbursement_private_other.active === 'Yes') type += type !== '' ? ' + Private Other' : 'Private Other';
    }

    if (reimbursement_public) {
      if (reimbursement_public.active === 'Yes') type += type !== '' ? ' + Public' : 'Public';
    }

    if (reimbursement_compassionate) {
      if (reimbursement_compassionate.active === 'Yes') type += type !== '' ? ' + Compassionate' : 'Compassionate';
    }

    if (reimbursement_fa) {
      if (reimbursement_fa.active === 'Yes') type += type !== '' ? ' + FA' : 'FA';
    }

    return type !== '' ? type : null;
  }

  getReimbursementActiveType(
    reimbursement_private?: any, 
    reimbursement_private_other?: any, 
    reimbursement_public?: any, 
    ): string | null {
    let type = '';
    if (reimbursement_private) {
      if (reimbursement_private.active === 'Yes') type = 'Active';
      else if (reimbursement_private.active === 'No') type = 'Inactive';
    }

    if (reimbursement_private_other) {
      if (reimbursement_private_other.active === 'Yes') type = 'Active'
      else if (reimbursement_private_other.active === 'No') type = 'Inactive'
    }

    if (reimbursement_public) {
      if (reimbursement_public.active === 'Yes') type = 'Active'
      else if (reimbursement_public.active === 'No') type = 'Inactive'
    }

    return type !== '' ? type : null;
  }

  public formatDate(date, format) {
    let myMoment: moment.Moment
    try {
      if (date.seconds) {
        myMoment = moment.unix(date.seconds);
      } else {
        myMoment = moment(date);
      }
      return myMoment.format(format);
    } catch {
      return null;
    }
  }


  public presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  public formate164(phone_number: string) {
    phone_number = phone_number.replace('-','').replace('(','').replace(')','').replace(/\s+/g,'').replace('+', '');
    if(phone_number.startsWith("1")) {
      phone_number = "+" + phone_number;
    } else {
      phone_number = "+1" + phone_number;
    }
    return phone_number;
  }
    
    sendFax(url)  {
      let confirm = this.alertCtrl.create({
        title: "Send Fax",
        message: "Please enter the fax number",
        inputs: [
          {
            name: 'fax_number',
            placeholder: 'fax number',
            type: 'tel'
          }
        ],
        buttons: [
          {
            text: "Cancel",
            handler: () => {
              // console.log("Don't update");
            }
          },
          {
            text: "Send Fax",
            handler: data => {
              let fax_number = data.fax_number;
              fax_number = fax_number.replace('-','').replace('(','').replace(')','').replace(/\s+/g,'').replace('+', '');
              if(fax_number.startsWith("1")) {
                fax_number = "+" + fax_number;
              } else {
                fax_number = "+1" + fax_number;
              }
              this.db.sendFax(data.fax_number, url).then(response => {
                console.log('Fax SID: ', response);
                const toast = this.toastCtrl.create({
                  message:
                    "Fax was successfully sent. Your confirmation is: " + response['sid'],
                  duration: 3000
                });
                toast.present();
              })
              .catch(err => {
                const errortoast = this.toastCtrl.create({
                  message:
                    "The fax could not be sent at this time.  Please try again. Error: " + err,
                  duration: 3000
                });
                errortoast.present();
              });
            }
          }
        ]
      });
      confirm.present();
    }
  }


// WEBPACK FOOTER //
// ./src/providers/utility/utility.ts